const POSTGRES_INSTANT_PATTERN =
  /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(\.\d+)?(Z|[+-]\d{2}(?::?\d{2})?)?$/;

const expandIsoOffset = (offset: string): string => {
  if (offset === "Z") {
    return "Z";
  }
  if (offset.length === 3) {
    return `${offset}:00`;
  }
  if (offset.length === 5) {
    return `${offset.slice(0, 3)}:${offset.slice(3)}`;
  }
  return offset;
};

const normalizePostgresInstantText = (value: string): string => {
  const match = POSTGRES_INSTANT_PATTERN.exec(value);
  if (match === null) {
    return value;
  }
  const datePart = match[1];
  const timePart = match[2];
  const fractionPart = match[3] ?? "";
  const offsetPart = match[4] ?? "Z";
  const milliseconds =
    fractionPart === "" ? "" : `.${fractionPart.slice(1).padEnd(3, "0").slice(0, 3)}`;
  return `${datePart}T${timePart}${milliseconds}${expandIsoOffset(offsetPart)}`;
};

export const parseInstant = (value: string | null | undefined): Date | null => {
  if (value == null) {
    return null;
  }
  const trimmed = value.trim();
  if (trimmed === "") {
    return null;
  }
  const nativeMs = Date.parse(trimmed);
  if (!Number.isNaN(nativeMs)) {
    return new Date(nativeMs);
  }
  const normalized = normalizePostgresInstantText(trimmed);
  if (normalized === trimmed) {
    return null;
  }
  const normalizedMs = Date.parse(normalized);
  if (Number.isNaN(normalizedMs)) {
    return null;
  }
  return new Date(normalizedMs);
};

export const toIsoInstantString = (value: string | null | undefined): string | null => {
  const parsed = parseInstant(value);
  if (parsed === null) {
    return null;
  }
  return parsed.toISOString();
};

export const formatSupportDate = (value: string | null | undefined): string => {
  const parsed = parseInstant(value);
  if (parsed === null) {
    return "—";
  }
  return parsed.toLocaleDateString("es-AR");
};

export const formatSupportDateTime = (value: string | null | undefined): string => {
  const parsed = parseInstant(value);
  if (parsed === null) {
    return "—";
  }
  return parsed.toLocaleString("es-AR");
};

export const formatSupportDateTimeMinutes = (value: string | null | undefined): string => {
  const parsed = parseInstant(value);
  if (parsed === null) {
    return "—";
  }
  return parsed.toLocaleString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
